
import React from 'react'

export const EmptyWrapper = ({title=''}) => (
    <div className="empty-wrapper">
        <div>
            <img src="/assets/empty.svg" alt="" />
            <h3>{title||'Blank!'}</h3>
        </div>
    </div>
)